var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addfujian"},_vm._l((_vm.attaArr),function(item,index){return _c('p',[_c('span',[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('a',{staticClass:"delete",attrs:{"href":item.url,"download":item.url,"target":"_blank"}},[_vm._v("[下载]")])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae5b41b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/attachment/index1.vue
// module id = null
// module chunks = 